import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'

class OurWork extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div id="scroll-target" className="container">
          <SectionTitle
            icon="icon-our-work.svg"
            title="Our Work"
          />

          <div className="layout layout--content layout--pb-lg">
            <div className="layout__item layout__item--half">
              <p className="copy--intro">Upon securing a working agreement GDL will form a strategy and commit funds to manage the professional team. Each team member/consultant is selected in line with their industry standing and sector specialisms</p>
            </div>
            <div className="layout__item layout__item--half">
              <p className="copy--intro">There is no such thing as a straight road in this industry and multiple changes or reviews of strategy are required and implemented along the way</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default OurWork;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Our-Work.js